import { configureStore } from "@reduxjs/toolkit";
import messagesReducer from "../features/messagesSlice.js";
import componentStateReducer from "../features/componentStateSlice.js";
import surveyReducer from "../features/surveySlice.js";
import sessionReducer from "../features/sessionSlice.js";
import userDetailsReducer from "../features/userDetailsSlice.js";

export default configureStore({
    reducer: {
        messages: messagesReducer,
        componentState: componentStateReducer,
        survey: surveyReducer,
        session: sessionReducer,
        userDetails: userDetailsReducer,
    },
});
